<ion-header>
  <ion-toolbar>
    <ion-title role="heading">browser-menu</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

</ion-content>
